module.exports = __webpack_public_path__ + "img/公司荣誉W.74dd3b87.svg";